const themeColors = {
  "icerik-ureticiligi": "#ff8f42",
  muzik: "#EB69FF",
  oyunculuk: "#6071e7",
  kurumsal: "#CBAA9A",
  workshop: "#5ac0de",
};

export default themeColors;
